import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHeroSection } from '../../hooks/useHeroSection';
import styles from './HeroSection.module.css';

const HeroSection = ({ size = "Desktop 1440" }) => {
    const navigate = useNavigate();
    const { 
        imageUrl, 
        buttonSvgUrl, 
        isLoading,
        error 
    } = useHeroSection();

    const getHorizontalWidth = useCallback(() => {
        switch (size) {
            case "Desktop 1440":
            case "Desktop 1200":
            case "Tablet":
                return 436;
            case "Phone":
                return 330;
            default:
                return 436;
        }
    }, [size]);

    const handleDiscoverClick = () => {
        navigate('/discover/all');
    };

    // Convertimos el tamaño a formato camelCase para las clases CSS
    const sizeClass = size.toLowerCase().replace(' ', '');

    // Si hay error, podríamos mostrar un estado de error o fallback
    if (error) {
        console.error('Error loading hero section assets:', error);
    }

    // Podríamos mostrar un skeleton loader mientras carga
    if (isLoading) {
        return (
            <div className={styles.heroSection}>
                <div className={`${styles.contentContainer} ${styles[sizeClass]}`}
                     style={{ width: getHorizontalWidth() }}>
                    {/* Aquí podrías añadir un skeleton loader si lo deseas */}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.heroSection}>
            <div 
                className={`${styles.contentContainer} ${styles[sizeClass]}`}
                style={{ width: getHorizontalWidth() }}
            >
                <div className={styles.imageButtonContainer}>
                    <div className={styles.imageContainer}>
                        {imageUrl && (
                            <img
                                src={imageUrl}
                                alt="Hero"
                                className={styles.image}
                            />
                        )}
                    </div>
                    {buttonSvgUrl && (
                        <img
                            src={buttonSvgUrl}
                            alt="New drops every week"
                            className={styles.buttonSvg}
                        />
                    )}
                </div>
                <div className={styles.textContainer}>
                    <h1 className={styles.title}>
                        The first platform connecting you to exciting waiting
                        list projects
                    </h1>
                    <p className={styles.description}>
                        Unparalleled visibility for businesses awaiting their
                        launch.
                    </p>
                </div>
                <div
                    className={styles.discoverAllButton}
                    onClick={handleDiscoverClick}
                >
                    <span className={styles.discoverAllText}>
                        Discover all
                    </span>
                </div>
            </div>
            <div className={styles.separator}></div>
        </div>
    );
};

export default HeroSection;